import { TopNav } from "../components/TopNav";
import { Footer } from "../components/Footer";

/**
 * Shared shell for the per-app marketing pages while they're still
 * scaffolded. Each app's stub renders this with its display name —
 * the user replaces the body with the real page content app by app.
 *
 * Intentionally bare: just the chrome (TopNav + Footer) and a
 * centred display-type heading so the route's working state is
 * obvious in the browser. No section frames, no copy, no demos —
 * the goal is a clean canvas, not a fake landing page.
 */
export function AppPagePlaceholder({ name }: { name: string }) {
  return (
    <>
      <TopNav />
      <main
        style={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--sp-3)",
          padding: "var(--sp-24) var(--sp-6)",
          textAlign: "center",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "var(--text-xs)",
            fontWeight: 500,
            letterSpacing: "var(--tracking-caps)",
            textTransform: "uppercase",
            color: "var(--muted)",
          }}
        >
          An Atlas Desk app
        </span>
        <h1
          style={{
            fontSize: "clamp(56px, 12vw, 132px)",
            fontWeight: 900,
            letterSpacing: "var(--tracking-tighter)",
            lineHeight: 0.9,
            margin: 0,
          }}
        >
          {name}
        </h1>
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "var(--text-xs)",
            color: "var(--muted)",
            letterSpacing: "var(--tracking-caps)",
            textTransform: "uppercase",
            marginTop: "var(--sp-4)",
          }}
        >
          Page coming soon
        </span>
      </main>
      <Footer />
    </>
  );
}
